import { installDomMutationGuard } from '@xometry/ui';
import { getMonitoringClient } from 'core/monitoring/monitoring';
import { createRoot } from 'react-dom/client';
import { onLCP } from 'web-vitals';

import { getI18nClient } from './common/config/i18n';
import { getYuzu } from './core/monitoring/Yuzu/Yuzu.utils';

export const bootstrap = async (node?: HTMLElement | null) => {
  const [monitoringClient, i18n] = await Promise.all([getMonitoringClient(), getI18nClient()]);
  void monitoringClient.init();

  if (!node) {
    throw new Error('No root node provided!');
  }

  try {
    const yuzu = getYuzu();
    yuzu.info('APP_START');

    onLCP((metric) => {
      yuzu.info('LCP', {
        value: metric.value || 0,
      });
    });

    void yuzu.start();
  } catch (e: unknown) {
    console.error(e);
  }

  // Before the first render: a translated page must not crash React's DOM commits.
  installDomMutationGuard();

  const root = createRoot(node);

  // TODO: We'll need this in fresh react router (if ever).
  // const basename = ENV_BASE_URL ? ENV_BASE_URL.replace(window.location.origin, '') : undefined;

  return {
    monitoringClient,
    root,
    i18n,
    // basename,
  };
};
